import { Box } from '@mui/material';

import {
  DisplayAvatarIcon1,
  DisplayAvatarIcon2,
  DisplayAvatarIcon3,
  DisplayAvatarIcon4,
  DisplayNoAvatarIcon,
} from 'enrollment/features/Shared/DisplayProfilePicture/DisplayAvatarIconList';
import { StyledAvatar } from 'enrollment/features/Shared/DisplayProfilePicture/DisplayProfilePictureStyled';

interface FamilyDrawerDisplayPictureProps {
  saveAvatarName: string;
  saveAvatarSkinTone: string;
  saveAvatarHairColor: string;
  saveAvatarShirtColor: string;
  size?: number;
}

export const FamilyDrawerDisplayPicture = ({
  saveAvatarName,
  saveAvatarSkinTone,
  saveAvatarHairColor,
  saveAvatarShirtColor,
  size,
}: FamilyDrawerDisplayPictureProps) => {
  return (
    <Box data-testid="displayPicturePaper">
      <StyledAvatar size={size}>
        {saveAvatarName === 'avatar1' && (
          <DisplayAvatarIcon1
            skinTone={saveAvatarSkinTone}
            hairColor={saveAvatarHairColor}
            shirtColor={saveAvatarShirtColor}
          />
        )}
        {saveAvatarName === 'avatar2' && (
          <DisplayAvatarIcon2
            skinTone={saveAvatarSkinTone}
            hairColor={saveAvatarHairColor}
            shirtColor={saveAvatarShirtColor}
          />
        )}
        {saveAvatarName === 'avatar3' && (
          <DisplayAvatarIcon3
            skinTone={saveAvatarSkinTone}
            hairColor={saveAvatarHairColor}
            shirtColor={saveAvatarShirtColor}
          />
        )}
        {saveAvatarName === 'avatar4' && (
          <DisplayAvatarIcon4
            skinTone={saveAvatarSkinTone}
            hairColor={saveAvatarHairColor}
            shirtColor={saveAvatarShirtColor}
          />
        )}
        {saveAvatarName === '' && <DisplayNoAvatarIcon />}
      </StyledAvatar>
    </Box>
  );
};
